module.exports = __webpack_public_path__ + "static/media/header-black.dcec9655.png";